import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule,FormsModule  } from '@angular/forms';
import { EwCommonModule, EwMaterialComponentsModule } from 'ew-common-lib';
import { EwMaIntegrationComponent } from './ew-ma-integration.component';
import { EwMaIntegrationService } from './ew-ma-integration.service';
import { IntegrationComponent } from './integration/integration.component';
import { AddItegrationComponent } from './add-itegration/add-itegration.component';
import { DeleteConfirmationComponent } from './delete-confirmation/delete-confirmation.component';
import { ListSelectIntegrationComponent } from './select-list-integration/select-list-integration.component';
import { TranslateModule, TranslateStore } from '@ngx-translate/core';
import { EwMaIntegrationTranslateService } from './services/ew-ma-integration-translate.service';
import { IntegrationformComponent } from './integrationform/integrationform.component';
//import { MatSelectModule } from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
//import {TooltipModule} from "ngx-tooltip";



export const translateModule = TranslateModule.forChild();

@NgModule({
  declarations: [
    EwMaIntegrationComponent,
    IntegrationComponent,
    AddItegrationComponent,
    DeleteConfirmationComponent,
    ListSelectIntegrationComponent,
    IntegrationformComponent    
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule ,
    EwCommonModule,
    EwMaterialComponentsModule,
    translateModule,
    //TooltipModule
   // MatSelectModule,
    NgxMatSelectSearchModule    
  ],
  providers: [TranslateStore,EwMaIntegrationTranslateService],
  exports: [
    EwMaIntegrationComponent,
    IntegrationComponent,
    AddItegrationComponent,
    DeleteConfirmationComponent,
    ListSelectIntegrationComponent
  ]
})
export class EwMaIntegrationModule {
  /**
   * @description
   * Ew-ma-Integration module exports
   * @param environment Local or Prod
   * @returns EwMaIntegrationModule module
   */
  public static forRoot(environment: any): ModuleWithProviders<EwMaIntegrationModule> {
    return {
      ngModule: EwMaIntegrationModule,
      providers: [
        EwMaIntegrationService,
        {
          provide: 'env', // you can also use InjectionToken
          useValue: environment,
        }        
      ],
    };
  }
}
